import { MenuItemTypes } from "@/constants/menu";
import classNames from "clsx";
import FeatherIcon from "feather-icons-react";
import React, { useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCommonStore } from "@/apps/common/store/useCommonStore";
import { defaults, cloneDeep } from "lodash-es";

interface MenuItems {
  item: MenuItemTypes;
  tag?: string;
  linkClassName?: string;
  className?: string;
  subMenuClassNames?: string;
  activeMenuItems?: string[];
  toggleMenu?: (item: MenuItemTypes, status: boolean) => void;
}

const _displayBadge = (badge:any)  => {
  if (badge) {

    const badgeDesp = badge?.text
    if (badgeDesp) {
      return (
        <>
          <span className="position-absolute top-2 start-101 translate-middle badge rounded-pill bg-light text-dark">
            {/* {badge?.text} */}
            <FeatherIcon icon={'bell'} className="hori-icon me-1" />
            {/* <span className="visually-hidden">New Sessions</span> */}
          </span>
        </>
      )
    }
  }
}

const MenuItem = ({ item, className, linkClassName }: MenuItems) => {
  return (
    <li className={classNames("nav-item", className)}>
      <MenuItemLink item={item} className={linkClassName} />
    </li>
  );
};

const MenuItemLink = ({ item, className}: MenuItems) => {

  //console.debug (`item - ${JSON.stringify(item)}`)
  const menuClick = (e: React.MouseEvent) => {
    if (
      e.currentTarget.classList.contains("active") &&
      window.location.pathname === e.currentTarget.getAttribute("href")
    ) {
      e.preventDefault();
      window.location.reload();
    }
  };

  return (
    <>
   
    <Link
      to={item.url!}
      target={item.target}
      className={classNames(className)}
      data-menu-key={item.key}
      onClick={menuClick}
    >
      {item.icon && <FeatherIcon icon={item.icon} className="hori-icon me-1" />}
      <span> {item.badge?.text ? (<strong>{item.label}</strong>) : item.label }</span>
      {_displayBadge(item?.badge)}
    </Link>
    </>
  );
};

/**
 * Renders the application menu
 */

interface AppMenuProps {
  menuItems: MenuItemTypes[];
}

const AppMenu = ({ menuItems }: AppMenuProps) => {
  const location = useLocation();
  const menuRef = useRef(null);
  const { canScheduleAppointment } = useCommonStore();
  const scheduleAppointment = {
    key: "schedule-appointment",
    icon: "calendar",
    label: "Schedule Another Session",
    isTitle: true,
    url: "/schedule-appointment",
  };
  //const menuItemsClone = structuredClone(menuItems);

  const updatedMenuItems = menuItems.map( item => {

    //console.debug (`item - ${JSON.stringify(item)}`)
    let data;
    if (item?.itemCallback){
      data = item?.itemCallback()
      //console.debug(`data - ${JSON.stringify(data)}`)
      item = {...data, ...item}

    }
          return item
    
  })

  const menuItemsClone = cloneDeep(updatedMenuItems)

  if (canScheduleAppointment) {
    menuItemsClone.push(scheduleAppointment);
  }


  return (
    <ul className="navbar-nav" ref={menuRef} id="main-side-menu">
      {(menuItemsClone || []).map((item, idx) => {
        const isActive = location?.pathname.startsWith(item?.url || "");
        return (
          <MenuItem
            key={idx}
            item={item!}
            className={classNames({ active: isActive })}
            linkClassName={classNames("nav-link", "dropdown-toggle", {
              active: isActive
            })}
          />
        );
      })}
    </ul>
  );
};

export default AppMenu;
